import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["orientation"];
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import SocialFollowRender from './SocialFollowRender';
import { PORTRAIT, LANDSCAPE } from './sf.config';
const SocialFollow = _ref => {
  let {
      orientation
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  const {
    socialNetworks = {}
  } = otherProps;
  const socialNetKeys = Object.keys(socialNetworks);
  const isPortrait = orientation === PORTRAIT;
  if (!socialNetKeys.length) return null;
  const divClassName = classnames({
    'social social--follow social--vertical': isPortrait,
    'social social--follow': !isPortrait
  });
  return /*#__PURE__*/React.createElement("div", {
    className: divClassName
  }, /*#__PURE__*/React.createElement(SocialFollowRender, _extends({
    isPortrait: isPortrait,
    socialNetKeys: socialNetKeys
  }, otherProps)));
};
SocialFollow.propTypes = {
  orientation: PropTypes.string
};
SocialFollow.defaultProps = {
  orientation: LANDSCAPE
};
export default SocialFollow;
//# sourceMappingURL=SocialFollow.js.map